<template>
    <div class="nav-media-folder-data">
        <div v-if="data.mediaType === 'folder' || data.mediaType === ''" class="nav-media-data__buttons">
            <button
                class="nav-media-data__button nav-media-data__button--select"
                @click="openUpload(data)"
            >
                UPLOAD FILES
            </button>
        </div>
        <div class="nav-media-folder-data__list">
            <div
                v-for="thumb in data.children"
                :key="thumb.id"
                class="nav-media-folder-data__thumb"
                @click="click(thumb.id)"
            >
                <img :src="thumb.thumbnailUrl">
                {{ thumb.name | ellipses(43, 16) }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import mapFilters from '@/utils/map-filters';
import {
    SET_NEW_PAGE_PATH, SHOW_DRAWER,
} from '@/store/types/mutation-types';

export default {
    name: 'media-folder-data',

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            name: '',
            id: '',
            url: null,
        };
    },

    methods: {
        ...mapMutations({
            showDrawer: SHOW_DRAWER,
            setNewPagePath: SET_NEW_PAGE_PATH,
        }),

        ...mapFilters(['ellipses']),

        openUploadDrawer(parentItem) {
            let id;

            if (parentItem) {
                id = parentItem.id;
            }

            this.setNewPagePath(id);
            this.showDrawer('media-upload-drawer');
        },
        openUpload() {
            const callback = () => this.openUploadDrawer(this.data);

            if (!this.changedData) {
                callback();
                return;
            }

            this.showPrompt({
                template: 'unsaved-changes',
                onContinue: callback,
            });
        },

        click(id) {
            this.$emit('select', id);
        },
    },
};
</script>

<style lang="scss">
.nav-media-folder-data {

    &__buttons {
        position: sticky;
        display: flex;
        bottom: 0;
    }

    &__button {
        color: var(--form-buttonColor);
        background-color: var(--form-buttonBackgroundColor);
        flex-grow: 1;
        min-height: 50px;
        border-radius: 3px;
        z-index: 2; // issue with z-index for toggles going over button
        transition: opacity 0.45s;

        &[disabled] {
            opacity: 0.5;
        }

        &:hover {
            color: var(--form-buttonHoverColor);
            background-color: var(--form-buttonHoverBackgroundColor);
        }
    }

    &__list {
      margin-top: 15px;
    }

    &__thumb {
        border-bottom: solid 1px rgba(155, 155, 155, 0.192);
        margin: 5px 0px 5px 0px;
        padding: 10px;
    }
}
</style>
